import React from 'react'

import * as commonStyles from '../components/styles'
import * as styles from './styles'
import { useAppSelector } from '../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

const ErrorView: React.FC = () => {
  const { content } = useAppSelector((state) => state.init)

  return (
    <Styled.ErrorView>
      <Styled.Intro>
        <h1>{content.errorView.title}</h1>
        <p>{content.errorView.description}</p>
        <p>{content.errorView.description_2}</p>
      </Styled.Intro>
    </Styled.ErrorView>
  )
}

export default ErrorView
